import type { NotificationStatusType } from '@eti/components';
import { DangerousHtmlContent, Notification } from '@eti/components';
import type { LoginNotificationType } from './models';

interface LoginMessageProps {
  className?: string;
  notification: LoginNotificationType;
}

const LoginMessage = ({ className, notification }: LoginMessageProps) => {
  return (
    <div id="loginMessage">
      <Notification
        className={className}
        dataTestId={notification.dataTestId}
        variant={notification.type as NotificationStatusType}
      >
        <DangerousHtmlContent content={notification.message} />
      </Notification>
    </div>
  );
};

export default LoginMessage;
